(function () {
  const config = parseConfig();
  const localFallbackStorageKey = 'shopfive-product-view-counter-v1';
  const pingStorageKey = 'shopfive-product-view-ping-v1';
  const pingTtlMs = 5 * 60 * 1000;
  const apiTimeoutMs = 5000;

  function parseConfig() {
    const c = (window.ShopFiveProductViewCounter || {});
    return {
      shop: normalizeText(c.shop || (window.Shopify && window.Shopify.shop) || ''),
      apiEndpoint: normalizeText(c.apiEndpoint || c.endpoint || '')
    };
  }

  function normalizeText(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function normalizeId(productId, handle) {
    return String(productId || handle || 'product').replace(/[^A-Za-z0-9_-]/g, '');
  }

  function seededCounterSeed(seedText) {
    const text = String(seedText || 'product');
    let hash = 0;
    for (let i = 0; i < text.length; i += 1) {
      hash = ((hash << 5) - hash) + text.charCodeAt(i);
      hash |= 0;
    }
    return 18 + Math.abs(hash % 30);
  }

  function readStorage(key, fallback) {
    try {
      return JSON.parse(localStorage.getItem(key)) || fallback;
    } catch (e) {
      return fallback;
    }
  }

  function writeStorage(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  function readPingStorage(productId) {
    try {
      return parseInt(sessionStorage.getItem(productId), 10) || 0;
    } catch (e) {
      return 0;
    }
  }

  function writePingStorage(productId, value) {
    try {
      sessionStorage.setItem(productId, String(value));
    } catch (e) {}
  }

  function shouldIncrement(productId) {
    const now = Date.now();
    const last = readPingStorage(productId);
    if (!last || now - last > pingTtlMs) {
      writePingStorage(productId, now);
      return true;
    }
    return false;
  }

  function toNumber(value) {
    const n = Number(value);
    return Number.isFinite(n) ? Math.max(0, Math.floor(n)) : null;
  }

  function safeText(value) {
    return value == null ? '' : String(value);
  }

  function getFallbackCount(productId, handle) {
    const key = normalizeId(productId, handle);
    const state = readStorage(localFallbackStorageKey, {});
    const entry = state[key] || {};
    const baseline = entry.seed || seededCounterSeed(key);
    const nextCount = (entry.count || 0) + 1;

    entry.seed = baseline;
    entry.count = nextCount;

    state[key] = entry;
    writeStorage(localFallbackStorageKey, state);

    return Math.max(1, baseline + nextCount);
  }

  function buildApiUrl(productId, handle, action) {
    if (!config.apiEndpoint) return null;
    let url;
    try {
      url = new URL(config.apiEndpoint, location.origin);
    } catch (e) {
      return null;
    }
    const qs = url.searchParams;
    qs.set('action', action);
    qs.set('shop', config.shop || location.hostname);
    if (productId) qs.set('product_id', productId);
    if (handle) qs.set('product_handle', handle);
    qs.set('pathname', location.pathname);
    qs.set('source', 'product-page');
    return url.toString();
  }

  function fetchCountFromApi(productId, handle, action) {
    const endpoint = buildApiUrl(productId, handle, action);
    if (!endpoint) {
      return Promise.reject(new Error('missing or invalid endpoint'));
    }

    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const signal = controller ? controller.signal : undefined;
    let timeoutId = null;
    if (controller) {
      timeoutId = setTimeout(function () {
        controller.abort();
      }, apiTimeoutMs);
    }

    return fetch(endpoint, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      cache: 'no-store',
      signal
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }
        return response.text();
      })
      .then(function (text) {
        if (timeoutId) clearTimeout(timeoutId);
        try {
          const data = JSON.parse(text);
          return toNumber(data && data.count);
        } catch (e) {
          return toNumber(text);
        }
      })
      .then(function (value) {
        if (value == null) {
          throw new Error('invalid count response');
        }
        return value;
      });
  }

  function renderMarker(marker, count) {
    const countNode = marker.querySelector('[data-product-view-count]');
    if (!countNode) return;
    const textNode = marker.querySelector('.product-view-counter__note') || marker.querySelector('.product-view-counter__text');
    const safeCount = toNumber(count);
    if (safeCount == null) return;

    countNode.textContent = safeCount.toLocaleString();
    marker.setAttribute('aria-label', String(safeCount) + ' customers are viewing this product');
    if (textNode && textNode.textContent && textNode.textContent.indexOf('are viewing this product') === -1) {
      textNode.textContent = textNode.textContent.replace(' are viewing this product', '').trim() + ' are viewing this product';
    }
  }

  async function applyMarker(marker) {
    const productId = normalizeText(marker.dataset.productId);
    const handle = normalizeText(marker.dataset.productHandle);
    const key = normalizeId(productId, handle);
    const doIncrement = shouldIncrement(key);

    if (!config.apiEndpoint) {
      renderMarker(marker, getFallbackCount(productId, handle));
      return;
    }

    try {
      const action = doIncrement ? 'increment' : 'read';
      const count = await fetchCountFromApi(productId, handle, action);
      renderMarker(marker, count);
      return;
    } catch (e) {
      const fallbackCount = getFallbackCount(productId, handle);
      renderMarker(marker, fallbackCount);
      return;
    }
  }

  function render(root) {
    const markers = root ? Array.prototype.slice.call(root.querySelectorAll('[data-product-view-counter]')) : [];
    markers.forEach(function (marker) {
      if (typeof marker.dataset.viewCounterHandled !== 'undefined') return;
      marker.dataset.viewCounterHandled = 'true';
      applyMarker(marker);
    });
  }

  function refresh() {
    render(document);
  }

  document.addEventListener('product-info:loaded', function (event) {
    setTimeout(function () {
      render((event && event.target) || document);
    }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();